/**
 * Loads the Zoho SalesIQ script.
 * @param {Function} readyCallback - The callback function to run after Zoho SalesIQ is ready.
 */
export default function loadZohoSalesIQ(readyCallback) {
  const { ZOHO_SALESIQ_WIDGET_CODE } = process.env

  if (!ZOHO_SALESIQ_WIDGET_CODE) {
    return
  }

  window.$zoho = window.$zoho || {}
  window.$zoho.salesiq = window.$zoho.salesiq || { ready() {} }

  document.body.addEventListener('mouseenter', loadZohoSalesIQ)

  function loadZohoSalesIQ() {
    const script = document.createElement('script')
    script.id = 'zsiqscript'
    script.defer = true
    script.src = `https://salesiq.zohopublic.com/widget?wc=${ZOHO_SALESIQ_WIDGET_CODE}`

    const firstScript = document.getElementsByTagName('script')[0]
    firstScript.parentNode?.insertBefore(script, firstScript)

    document.body.removeEventListener('mouseenter', loadZohoSalesIQ)

    window.$zoho.salesiq.ready = () => {
      if (readyCallback) {
        readyCallback()
      }
    }
  }
}
